// @ts-nocheck
import { Dialog, Button } from '@workspace/design-system/src/components';

interface PaymentCancelTossDialogProps {
    onClose: () => void;
    onConfirm: () => void;
}

export function PaymentCancelTossDialog({ onClose, onConfirm }: PaymentCancelTossDialogProps) {
    return (
        <Dialog>
            <Dialog.Content>
                <Dialog.Header title="이 채널의 요금제를 취소하시겠습니까?" type="destructive" showIcon />

                <Dialog.Body>
                    <p className="text-[14px] text-[#595959] leading-[20px] tracking-[-0.1px]">
                        토스에서 결제를 취소하면, 그 즉시 요금제가 자동으로 취소돼요.
                    </p>
                    <span className="text-sm font-normal font-['Pretendard'] leading-5 text-[#D15445]">
                        ※ 취소 후에는 복구할 수 없습니다.
                    </span>
                </Dialog.Body>

                <Dialog.Footer>
                    <Button
                        type="button"
                        onClick={onClose}
                    >
                        닫기
                    </Button>
                    <Button
                        type="button"
                        styleType="destructive"
                        onClick={onConfirm}
                    >
                        토스에서 결제 취소
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

